export default [
  {
    title: 'مدیریت رژیم ها',
    icon: 'bx bx-food-menu',
    children: [
      {
        title: 'رژیم ها',
        route: { name: 'diet' },
        resource: 'DietManager',
        action: 'show',
      },
      {
        title: 'دوره ها',
        route: { name: 'dietduration' },
        resource: 'DietDurationManager',
        action: 'show',
      },
      {
        title: 'قیمت ها',
        route: { name: 'dietdurationprice' },
        resource: 'DietDurationPriceManager',
        action: 'show',
      },
      {
        title: 'کالری های جایگزین فستینگ',
        route: { name: 'alternativeCalorie' },
        resource: 'DietDurationPriceManager',
        action: 'show',
      },
    ],
  },
]
